/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".bar-chart-stacked svg{shape-rendering:crispEdges}.bar-chart-stacked .group-label{font-size:smaller;font-weight:700;text-anchor:start;fill:#000;text-shadow:0 1px 0 #fff,0 -1px 0 #fff,1px 0 0 #fff,-1px 0 0 #fff}.bar-chart-stacked .group-total{font-size:smaller;text-anchor:end;fill:#000;text-shadow:0 1px 0 #fff,0 -1px 0 #fff,1px 0 0 #fff,-1px 0 0 #fff}.bar-chart-stacked .axis path{display:none}.bar-chart-stacked .axis line{fill:none;stroke:#000}"];
export { styles as styles };
